import { render, staticRenderFns } from "./SectionProximamenteIa.vue?vue&type=template&id=5ccac752&scoped=true"
import script from "./SectionProximamenteIa.vue?vue&type=script&lang=js"
export * from "./SectionProximamenteIa.vue?vue&type=script&lang=js"
import style0 from "./SectionProximamenteIa.vue?vue&type=style&index=0&id=5ccac752&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ccac752",
  null
  
)

export default component.exports